<template>
  <div id="companyBasic">
    <a-form
      ref="step1Ref"
      class="ant-round-form material-company-register-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >
      <a-form-item name="merchantRegistrationType" style="text-align: center" :label="$t('pages_merchant_154')">
        <a-select
          v-model:value="modelForm.merchantRegistrationType"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.merchantRegistrationTypeDisabled"
        >
          <a-select-option v-for="item in merchantRregistrationType" :key="item.value" :value="item.value">{{ item.key
          }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.merchantRegistrationTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.merchantRegistrationTypeMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item name="registrationAddress" :label="$t('pages_merchant_155')">
        <a-input
          v-model:value="modelForm.registrationAddress"
          size="large"
          allow-clear
          :disabled="modelForm.registrationAddressDisabled"
          :placeholder="$t('pages_merchant_179')"
        />
        <div v-if="!modelForm.registrationAddressDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.registrationAddressMessage }}</span>
        </div>
      </a-form-item>
      <!-- 真实经营地址与注册地址是否一致 -->
      <a-form-item name="truthSwitch" :label="$t('pages_merchant_182')">
        <a-switch v-model:checked="modelForm.truthSwitch" checked-children="是" un-checked-children="否" />
      </a-form-item>
      <!-- 真实营业地址 -->
      <a-form-item
        v-if="!modelForm.truthSwitch"
        name="mailingAddress"
        :label="$t('pages_holder_070')"
      >
        <a-input
          v-model:value="modelForm.mailingAddress"
          size="large"
          allow-clear
          :disabled="modelForm.merchantNameEnDisabled"
          :placeholder="$t('pages_merchant_179')"
        />

      </a-form-item>
      <!-- 上传 -->
      <a-form-item
        v-if="!modelForm.truthSwitch"
        name="proofOfRealBusinessAddress"
        :label="$t('pages_merchant_157')"
      >
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant_035') }}</span>
          <a-popover title="请按要求提供以下其中一份文件验证您的经营地址">
            <template #content>
              <p>可接受的地址验证文件清单：</p>
              <p>1.最有效营业证明：同名公司银行对账单附地址的首页.  (日期不超过3个月)</p>
              <p>2.同名公司的官方水电费账单附有地址.   (日期不超过3个月)</p>
              <p>3.具联系地址的公司官方网站, 产品目录, 服务册子, 广告单, 宣传单张</p>
              <p>4.UBO 的银行账户证明.   (日期不超过3个月)</p>
              <p>5.提供中国自营或有直接业务联系公司,其商品的业务性质应与香港公司匹配。</p>
            </template>
            <span type="primary" style="color: #BA8438">{{ $t('pages_merchant_183') }}</span>
          </a-popover>
          <span>{{ $t('pages_merchant_047') }}{{ $t('pages_merchant_157') }}{{ $t('pages_merchant_048') }}</span>
        </div>
        <upload-auto
          ref="uploadRef"
          v-model:file-content="modelForm.proofOfRealBusinessAddress"
          accept=".jpg,.jpeg,.png,.pdf,.bmp"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.proofOfRealBusinessAddressDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.proofOfRealBusinessAddressDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.proofOfRealBusinessAddressMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item name="companyAddressType" style="text-align: center" :label="$t('pages_merchant_156')">
        <a-select
          v-model:value="modelForm.companyAddressType"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.countryCodeDisabled"
        >
          <a-select-option v-for="item in companyAddressType" :key="item.value" :value="item.value">{{ $t(item.key)
          }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.companyAddressTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.companyAddressTypeMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item style="text-align: right">
        <a-button html-type="submit" type="primary" shape="round" style="min-width: 138px; margin-top: 24px">{{
          $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, onUnmounted, nextTick } from 'vue'
import companyAddressType from '@/common/companyAddressType'
import merchantRregistrationType from '@/common/merchantRregistrationType'
import UploadAuto from '@/components/upload-auto'
import i18n from '@/locale'
export default {
  name: 'CompanyBasic',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    countries: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup(props, ctx) {
    const timer = null
    const uploadRef = ref(null)
    const step1Ref = ref(null)
    const state = reactive({
      exist: false,
      language: localStorage.getItem('locale-language') || 'zh',
      rules: {
        registrationAddress: [{ required: true, message: i18n.global.t('pages_merchant_155') }, {
          pattern: new RegExp(/^[ ,.0-9A-Za-z]+$/),
          message: i18n.global.t('pages_holder_071')
        }],
        mailingAddress: [{ required: true, message: i18n.global.t('pages_holder_070') }, {
          pattern: new RegExp(/^[ ,.0-9A-Za-z]+$/),
          message: i18n.global.t('pages_holder_071')
        }],
        proofOfRealBusinessAddress: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_157') }]
      }
    })

    state.modelForm = computed(() => {
      return props.model
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    const submit = () => {
      ctx.emit('next', '2-1')
    }

    nextTick(() => {
      const { proofOfRealBusinessAddress } = state.modelForm
      if (proofOfRealBusinessAddress.length !== 0 && uploadRef.value) uploadRef.value.fileListRefresh(proofOfRealBusinessAddress)
    })
    return {
      step1Ref,
      submit,
      uploadRef,
      companyAddressType,
      merchantRregistrationType,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#companyBasic {
}
</style>
